import { api } from "api/api";
import { AxiosError } from "axios";
import Pessoa from "model/administracao/cadastro/Pessoa";
import Produto from "model/administracao/cadastro/produto/Produto";
import Usuario from "model/administracao/cadastro/Usuario";
import HorarioDia from "model/meta/producao/HorarioDia";
import MetaPorUsuarioRelatorioFilters from "model/meta/producao/MetaPorUsuarioRelatorioFilters";
import MetaProducao from "model/meta/producao/MetaProducao";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta, DataTableOperatorFilterMetaData } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class MetaProducaoService implements BaseServiceCadastros<MetaProducao> {

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/metaProducao/pesquisar`;
            url += getFilters(filters);

            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<MetaProducao>((resolve, reject): void => {
            api
                .get(`/metaProducao/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(metaProducao: MetaProducao) {
        return new Promise<MetaProducao>((resolve, reject): void => {
            api
                .post(`/metaProducao/incluir`, JSON.stringify(metaProducao))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(metaProducao: MetaProducao) {
        return new Promise<MetaProducao>((resolve, reject): void => {
            api
                .put(`/metaProducao/editar`, JSON.stringify(metaProducao))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/metaProducao/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    produtos() {
        return new Promise<Produto[]>((resolve, reject): void => {
            api
                .get(`/metaProducao/produtos`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    clientes() {
        return new Promise<Pessoa[]>((resolve, reject): void => {
            api
                .get(`/metaProducao/clientes`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    usuarios() {
        return new Promise<Usuario[]>((resolve, reject): void => {
            api
                .get(`/metaProducao/usuarios`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    horariosDia() {
        return new Promise<HorarioDia[]>((resolve, reject): void => {
            api
                .get(`/metaProducao/horariosDia`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    gerarRelatorioMetaPorUsuario(filters?: MetaPorUsuarioRelatorioFilters) {
        return new Promise<string>((resolve, reject): void => {
            let url = `/metaProducao/report/metaPorUsuario`;
            console.log(filters);
            if (filters) {
                url += "?filters="+encodeURIComponent(JSON.stringify(filters));
            }
            api
                .get(url, { responseType: 'arraybuffer' })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });;
    }
}

export default MetaProducaoService;